import { useEffect } from 'react';
import { store } from '@reduxLocal/persistState';
import {
	OPEN_MESSAGES,
	HIDE_MESSAGE_MODAL,
	NAVIGATE_TAB,
	SHOW_MESSAGE_MODAL,
} from '@reduxLocal/actions/types';

export const useMessageModal = ({ handleOpen, closeMessage, setAiSummary }) => {
	useEffect(() => {
		const unsubscribe = store.subscribe(() => {
			const action = store.getState().lastAction;
			if (!action) return;

			if (action.type === SHOW_MESSAGE_MODAL) {
				console.log('OPEN MENU action dispatched');
				setAiSummary('');
				// DO NOT call handleOpen() here - it causes infinite loop!
				// handleOpen() dispatches SHOW_MESSAGE_MODAL again, which triggers this listener again
				// The Redux reducer already handles showing the modal based on SHOW_MESSAGE_MODAL action
				// handleOpen(); // ❌ REMOVED - causes infinite loop
			}

			// Fixed: Only close on HIDE_MESSAGE_MODAL, not NAVIGATE_TAB to prevent infinite loop
			if (action.type === HIDE_MESSAGE_MODAL) {
				console.log('CLOSED MENU action dispatched');
				setAiSummary('');
				// closeMessage(); // ❌ REMOVED - same issue, causes infinite loop
				// The Redux reducer already handles hiding the modal
			}
		});

		return () => {
			unsubscribe(); // ✅ Properly unsubscribe
		};
	}, [handleOpen, closeMessage, setAiSummary]); // ✅ Added dependencies
};
